export default __webpack_public_path__ + "static/media/icon_Reset.707b6029.svg";